import styled from 'styled-components';
import { StyledPrimaryButton } from '@/Shared/StyledElements';
import { CloseIcon } from '@/icons/index';

export const StyledActionsContainer = styled.div`
	align-items: center;
	display: flex;
	justify-content: center;

	button:not(:last-child) {
		margin-right: var(--spacing-4);
	}
`;

export const StyledUtilsContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;

	${StyledPrimaryButton} {
		align-self: flex-start;
		margin-right: auto;
	}
`;

export const modalStyles: ReactModal.Styles = {
	content: {
		backgroundColor: 'var(--modal-bg)',
		border: 'none',
		inset: 'initial',
		margin: 'auto',
		maxHeight: '800px',
		maxWidth: '900px',
		overflow: 'hidden auto',
		position: 'relative',
		width: '95%',
	},
	overlay: {
		backgroundColor: 'var(--modal-overlay)',
		display: 'flex',
		justifyContent: 'center',
		zIndex: 1,
	},
};

export const StyledModalBody = styled.div`
	margin-bottom: var(--spacing-8);

	form {
		margin-bottom: var(--spacing-8);
	}
`;

export const StyledFooterBody = styled.div`
	text-align: right;
`;

export const StyledModalHeader = styled.div`
	align-items: center;
	box-shadow: 0px 2px 0px -1px rgb(50 50 50 / 10%);
	display: flex;
	margin-bottom: var(--spacing-8);
	padding-bottom: var(--spacing-4);
`;

export const StyledCloseIcon = styled(CloseIcon as any)`
	background-color: var(--tab-group-color);
`;

export const StyledNotification = styled.div`
	background-color: var(--warning-bg-color);
	border-radius: 6px;
	bottom: var(--spacing-4);
	color: var(--warning-text-color);
	display: flex;
	margin-bottom: var(--spacing-4);
	padding: 4px var(--spacing-4);

	svg {
		fill: var(--warning-text-color);
		margin-right: var(--spacing-4);
		width: 40px;
	}
`;
